module.exports = __webpack_public_path__ + "img/header-engagementRingsBestseller.c25caa4.jpg";